export default {
    hasCustomNavbar: true,
    hasAnimations: true,
    hasParticles: true,
    particles: {
        icons: ['mdi-water'],
        colors: ['light-blue', 'blue', 'dark-blue', 'indigo'],
        opacity: [10, 30],
        size: [15, 25],
        time: [2, 4],
        amount: 6,
        rotate: false
    },
    light: {
        primary: '#2A53B3',
        secondary: '#424242',
        accent: '#275A39',
    },
    dark: {
        primary: '#2A53B3',
        secondary: '#424242',
        accent: '#275A39',
    }
}
